import styled from "@emotion/styled";
import {
  COLOR_APP_TEXT,
  COLOR_PRIMARY,
  FONT_SIZE_HEADER,
  FONT_SIZE_HEADER_MOBILE,
  HEADER_FONT_FAMILY,
  MOBILE_SCREEN,
  FONT_SIZE_XLARGE,
  TEXT_FONT_FAMILY,
  LINE_HEIGHT_XLARGE,
  FONT_SIZE_XLARGE_MOBILE,
  FONT_SIZE_HEADER2,
} from "../theme";

export const Header = styled.h1`
  font-size: ${FONT_SIZE_HEADER};
  text-align: left;
  font-family: ${HEADER_FONT_FAMILY};
  font-weight: 400;
  color: ${COLOR_APP_TEXT};
  line-height: ${LINE_HEIGHT_XLARGE};
  ${MOBILE_SCREEN} {
    font-size: ${FONT_SIZE_HEADER_MOBILE};
  }
`;

export const Header2 = styled.h2<{ fontWeight?: number }>`
  font-size: ${FONT_SIZE_HEADER2};
  text-align: left;
  font-family: ${HEADER_FONT_FAMILY};
  font-weight: ${({ fontWeight }) => fontWeight ?? 400};
  color: ${COLOR_APP_TEXT};
  line-height: ${LINE_HEIGHT_XLARGE};
  ${MOBILE_SCREEN} {
    font-size: ${FONT_SIZE_HEADER_MOBILE};
  }
`;

export const HeaderXLarge = styled(Header)`
  font-size: ${FONT_SIZE_XLARGE};
  ${MOBILE_SCREEN} {
    font-size: ${FONT_SIZE_XLARGE_MOBILE};
  }
`;

export const CenterHeader = styled(Header)`
  text-align: center;
`;

export const SubHeader = styled(Header)`
  text-align: center;
  font-weight: 600;
  color: ${COLOR_PRIMARY};
`;

export const PopupHeader = styled(Header)`
  font-size: ${FONT_SIZE_XLARGE};
  text-align: center;
  font-family: ${TEXT_FONT_FAMILY};
  font-weight: 400;
  color: ${COLOR_APP_TEXT};
`;
